"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateVSOP87 = exports.calculateVSOP87Angle = void 0;
var angleCalc_1 = require("../../utils/angleCalc");
function calculateVSOP87Angle(terms, t) {
    var result = calculateVSOP87(terms, t);
    return (0, angleCalc_1.rad2deg)(result);
}
exports.calculateVSOP87Angle = calculateVSOP87Angle;
function calculateVSOP87(terms, t) {
    var result = 0.0;
    terms.forEach(function (term, key) {
        result += _sumUpTerm(term, t) * Math.pow(t, key);
    });
    return result;
}
exports.calculateVSOP87 = calculateVSOP87;
function _sumUpTerm(terms, t) {
    var result = 0.0;
    terms.forEach(function (term) {
        var a = term[0] || 0;
        var b = term[1] || 0;
        var c = term[2] || 0;
        result += a * Math.cos(b + c * t);
    });
    return result;
}
